import React, { useRef } from "react";
import PropTypes from "prop-types";
import { IconButton, Tooltip } from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";

/**
 * Folder picker component to select a local scripts directory
 * and pass all contained files to parent component.
 */
const ScriptFolderSelector = ({ onFolderSelected }) => {
  const fileInputRef = useRef(null);

  const handleFolderSelected = (event) => {
    const files = Array.from(event.target.files || []);
    if (files.length > 0 && onFolderSelected) {
      onFolderSelected(files);
    }
  };

  return (
    <>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        multiple
        // ✅ Only keep the webkitdirectory attribute (no "directory")
        webkitdirectory="true"
        onChange={handleFolderSelected}
      />
      <Tooltip title="Upload Scripts">
        <IconButton
          color="primary"
          onClick={() => fileInputRef.current && fileInputRef.current.click()}
        >
          <UploadIcon />
        </IconButton>
      </Tooltip>
    </>
  );
};

// ✅ PropTypes validation
ScriptFolderSelector.propTypes = {
  onFolderSelected: PropTypes.func.isRequired,
};

export default ScriptFolderSelector;
